<template>
    <div class="sdr-box">
        <h5 class="box-title">{{ aboutsundair[getCurrentLocale] }}</h5>
        <p v-html="aboutsundairtext[getCurrentLocale]"></p>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    /* >>> *************************************************************** / /* Data */
    data: function() {
        return {
            aboutsundair: {
                en: 'About FBR/Schauinsland',
                de: 'Über FBR/Schauinsland',
            },
            aboutsundairtext: {
                en: '<strong>FBR/Schauinsland</strong> is a ...',
                de: '<strong>FBR/Schauinsland</strong> ist eine ...',
            },
            // currentLocale: 'de',
        };
    }, // eof data()
    /* <<< ****************************************************************/

    /* >>> *************************************************************** / /* Computed */
    computed: {
        ...mapGetters(['getCurrentLocale']),
    }, // eof computed{}
    /* <<< ****************************************************************/
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/shared/sidebar/AboutSundairBox.vue